<!--
  - Copyright (c) 2022 by 安徽网才信息技术股份有限公司
  -
  - 除非事先获得版权所有人的许可, 禁止以下几项行为:
  - 1. 对该软件的任何源代码和技术文档进行任意形式的打包、分发或复制用于其他目的。
  - 2. 向第三方透露任何与该软件相关的源代码或技术文档。
  - 3. 更改或删除软件或源码中的版权声明。
  -
  -->

<template>
    <div id="app">
        <LayoutHeader v-if="!$store.state.meta.model || $store.state.meta.model === '1'" />
        <xa-layout-header v-else-if="$store.state.meta.model === '2'" />
        <xa-layout-header v-else />
        <div class="main">
            <router-view />
        </div>
        <Feedback />
        <LayoutFooter v-if="!$store.state.meta.model || $store.state.meta.model === '1'" />
        <xa-layout-footer v-else-if="$store.state.meta.model === '2'" />
        <xa-layout-footer v-else />
    </div>
</template>

<script>
import LayoutHeader from '@/components/layout-header';
import LayoutFooter from '@/components/layout-footer';
import XaLayoutHeader from '@/components/xa-layout-header';
import XaLayoutFooter from '@/components/xa-layout-footer';
import Feedback from '@/components/feedback';

export default {
    name: 'AppMain',
    components: {
        XaLayoutFooter,
        XaLayoutHeader,
        LayoutHeader,
        LayoutFooter,
        Feedback
    }
};
</script>

<style scoped>

</style>
